import { TYPE_INDEXATION_INDICE } from '@/configuration/baux/contrat/contratConf';
import formatDate from '@/services/general/formatDate';

export function formatIndice(valeur, date) {
  return [valeur, formatDate(date)]
    .filter(el => !!el || el === 0).join(' - ');
}

function getItemIndiceValeurs(indiceValeurs, itemIndexe) {
  if (itemIndexe.typeIndexation != null
      && itemIndexe.typeIndexation !== TYPE_INDEXATION_INDICE) return null;
  const findIndice = indiceValeurs
    .find(el => el.id === itemIndexe.indiceReferenceId);
  if (!findIndice) return null;
  const valeurReference = itemIndexe.valeurIndexationReference;
  const dateReference = itemIndexe.dateIndexationReference;
  const indiceFormatReference = formatIndice(valeurReference, dateReference);
  const indiceValeurReference = findIndice.indiceValeurs
    .find(el => formatIndice(el.valeurIndice, el.dateReference)
      === indiceFormatReference);
  const valeurActuel = itemIndexe.valeurIndexationActuel;
  const dateActuel = itemIndexe.dateIndexationActuel;
  const indiceFormatActuel = formatIndice(valeurActuel, dateActuel);
  const indiceValeurActuel = findIndice.indiceValeurs
    .find(el => formatIndice(el.valeurIndice, el.dateReference) === indiceFormatActuel);

  return ({ indiceValeurReference, indiceValeurActuel });
}

export default getItemIndiceValeurs;
